export const SocketEvents = {
  opportunity: {
    aiAction: "opportunity-ai-action",
    joinAiAction: "join-opportunity-ai-action",
    listUpdated: "opportunities_list_updated",
    pipelineAttributeCreated: "opportunity:pipeline:attribute:created",
  },
  recentlyViewed: {
    updated: "recently_viewed_updated",
  },
  gmail: {
    connectionStatusUpdated: "gmail_connection_status_updated",
    syncProgress: "gmail_sync_progress",
  },
  googleCalendar: {
    connectionStatusUpdated: "google_calendar_connection_status_updated",
    syncProgress: "google_calendar_sync_progress",
    calendarEventsUpdated: "google_calendar_events_updated",
  },
  docusign: {
    syncProgress: "docusign_sync_progress",
  },
  subscription: {
    updated: "subscription_updated",
  },
};
